<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}合同管理</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">合同基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="合同单号" prop="no">
                <el-input disabled v-model="form.no" placeholder="系统自动生成合同单号" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="合同类型" prop="contractCategoryId">
                <el-select :disabled="!editMode" v-model="form.contractCategoryId" style="width: 90%" filterable placeholder="请选择合同类型" @change="contractChange">
                  <el-option v-for="item in STATIC_ContractType" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="合同编号" prop="contractNo">
                <el-input :disabled="!editMode" v-model="form.contractNo" placeholder="请填写合同编号" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="合同名称" prop="name">
                <el-input :disabled="!editMode" v-model="form.name" placeholder="请填写合同名称" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="供应商" prop="supplierName">
                <el-select :disabled="!editMode" v-model="form.supplierName" style="width: 90%" filterable placeholder="请填写供应商" :filter-method="getSuppliers" @change="supplierChange">
                  <el-option v-for="item in STATIC_Suppliers" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="联系人" prop="supplierContactorName">
                <el-input :disabled="!editMode" v-model="form.supplierContactorName" placeholder="系统自动带出联系人" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="联系方式" prop="supplierPhone">
                <el-input :disabled="!editMode" v-model="form.supplierPhone" placeholder="系统自动带出联系方式" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="甲方联系人" prop="contactor">
                <el-input :disabled="!editMode" v-model="form.contactor" placeholder="请填写甲方联系人" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="联系方式" prop="phone">
                <el-input :disabled="!editMode" v-model="form.phone" placeholder="请填写联系方式" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="合同签订时间" prop="startDate">
                <el-date-picker :disabled="!editMode" v-model="form.startDate" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="请选择合同签订时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="合同有效日期" prop="endDate">
                <el-date-picker :disabled="!editMode" v-model="form.endDate" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="请选择合同有效日期" :picker-options="{
                    disabledDate(v) {
                      return receivingDisabledDate(v);
                    },
                  }">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="到货日期" prop="arrivalDate">
                <el-date-picker :disabled="!editMode" v-model="form.arrivalDate" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="请选择到货日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="createdTime">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 90%">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人" prop="createdUserName">
                <el-input v-model="form.createdUserName" disabled style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属部门" prop="ownerDeptName">
                <el-input v-model="form.ownerDeptName" disabled style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="合同产品数" prop="totalNumber">
                <el-input disabled v-model="form.totalNumber" placeholder="根据下方详情自动计算" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="合同金额" prop="totalAmount">
                <el-input disabled v-model="form.totalAmount" placeholder="根据下方详情自动计算" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="合同内容" prop="content">
                <el-input :disabled="!editMode" v-model="form.content" placeholder="请填写合同内容" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="" prop="fileInfos">
                <!-- <my-upload
                  :canEdit="editMode"
                  @filesChange="filesChange"
                  :isLimitMaxSiz="true"
                  :oldList="form.fileInfos"
                ></my-upload> -->
                <UploadFileList label="上传附件" :fileList="form.fileInfos ? [form.fileInfos[0]] : []" btnShowType="always" :multipleFile="false" :showFileList="false" :editMode="editMode" @fileChange="filesChange"></UploadFileList>
                <!-- <el-upload :disabled="!editMode" multiple :action="uploadAction" :headers="uploadHeaders" :on-preview="openImageViewer" :limit="5" :file-list="form.fileInfos" :on-remove="onFileRemove" :on-success="(response, file, fileList) => onUploadSuccess(response, file, fileList)">
                  <el-button class="btn default" size="small">点击上传</el-button>
                </el-upload> -->
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">招标信息</span>
          </div>

          <el-row>
            <el-col :span="6">
              <el-form-item label="产品来源" prop="assetSource">
                <el-select :disabled="!editMode" v-model="form.assetSource" placeholder="请选择产品来源" style="width: 90%">
                  <el-option v-for="item in STATIC_ProductSource" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="招标形式" prop="biddingMode">
                <el-select :disabled="!editMode" v-model="form.biddingMode" placeholder="请选择招标形式" style="width: 90%">
                  <el-option v-for="item in BiddingModeTypeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="预算合计" prop="totalBudget">
                <el-input-number :disabled="!editMode" v-model="form.totalBudget" :min="0" :precision="4" :controls="false" placeholder="请填写预算合计" style="width: 90%"></el-input-number>
                <!-- <el-input :disabled="!editMode" v-model="form.totalBudget" placeholder="请填写预算合计" style="width:90%"></el-input> -->
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="立项依据" prop="projectBasis">
                <el-input :disabled="!editMode" v-model="form.projectBasis" placeholder="请填写立项依据" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">资产详细信息</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
          </div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column show-overflow-tooltip type="selection" fixed width="50" align="center" />
            <!-- <el-table-column type="expand">
              <template slot-scope="scope">
                <el-descriptions class="margin-top" style="width:500px;margin-left:107px" :column="3" v-for="(item, index) in scope.row.details" :key="index">
                  <el-descriptions-item label="资金来源">{{ item.capitalSourceName }}</el-descriptions-item>
                  <el-descriptions-item label="比例/金额">{{item.ratio}} / {{item.amount}}</el-descriptions-item>
                </el-descriptions>
              </template>
            </el-table-column> -->
            <el-table-column show-overflow-tooltip label="资产编码" align="center" width="140" prop="fixedAssetNo" />
            <el-table-column show-overflow-tooltip label="资产名称" align="center" width="130" prop="fixedAssetName" />
            <el-table-column show-overflow-tooltip label="规格型号" align="center" width="130" prop="specName" />
            <!-- <el-table-column show-overflow-tooltip label="品牌" align="center" width="100" prop="brandName" /> -->
            <el-table-column show-overflow-tooltip label="生产厂家" align="center" width="130" prop="manufacturerName" />
            <el-table-column show-overflow-tooltip label="数量" align="center" width="80" prop="number" />
            <el-table-column show-overflow-tooltip label="已建卡数量" align="center" min-width="110" prop="cardNumber" />
            <el-table-column show-overflow-tooltip label="单价" align="center" width="80" prop="price" />
            <el-table-column show-overflow-tooltip label="已验收数量" align="center" width="100" prop="checkedNumber" />
            <el-table-column show-overflow-tooltip label="单位" align="center" width="80" prop="unitName" />
            <el-table-column show-overflow-tooltip label="总金额" align="center" width="100" prop="totalAmount" />
            <el-table-column show-overflow-tooltip label="出厂日期" align="center" width="120" prop="productionDate" />
            <el-table-column show-overflow-tooltip label="保修期（月）" align="center" width="120" prop="warranty" />
            <el-table-column show-overflow-tooltip label="保修到期时间" align="center" width="160" prop="dueDate">
              <template slot-scope="scope">
                {{ parseTime(new Date(scope.row.dueDate), "{y}-{m}-{d}") }}
              </template>
            </el-table-column>

            <el-table-column show-overflow-tooltip label="配件" align="center" width="100" prop="parts" />
            <el-table-column show-overflow-tooltip label="备注" align="center" min-width="120" prop="remark" />

            <template v-for="(i, index) in intArr">
              <el-table-column v-if="index < capitalSourcemaxCount" :key="(i - 1) * 2" show-overflow-tooltip :label="'资金来源（' + Arabia_To_SimplifiedChinese(i) + '）'" align="center" width="150" prop="capitalSourceOneName">
                <template slot-scope="scope">
                  <span v-if="scope.row.details.length >= i">{{
                    scope.row.details[i - 1].capitalSourceName
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column v-if="index < capitalSourcemaxCount" :key="(i - 1) * 2 + 1" show-overflow-tooltip label="比例/金额" align="center" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.details.length >= i">{{ scope.row.details[i - 1].ratio }} /
                    {{ scope.row.details[i - 1].amount }}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">付款信息</span>
          </div>

          <el-row>
            <el-col :span="6">
              <el-form-item label="付款类型" prop="paymentType">
                <el-select :disabled="!editMode" v-model="form.paymentType" placeholder="请选择付款类型" style="width: 90%">
                  <el-option v-for="item in PaymentTypeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="付款方式" prop="paymentMode">
                <el-select :disabled="!editMode" v-model="form.paymentMode" placeholder="请选择付款方式" style="width: 90%">
                  <el-option v-for="item in PaymentModeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="付款人" prop="UserName">
                <el-select :disabled="formMode == 0" v-model="form.UserName" style="width: 90%" filterable placeholder="请选择付款人" :filter-method="getUsers" @change="userChange">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form label-position="top" label-width="80px" ref="childPaymentForm" :model="form" :rules="paymentRules">
            <template v-for="(row, index) in form.paymentDetails">
              <el-row :key="index">
                <el-col :span="6">
                  <el-form-item prop="paymentRatio">
                    <label slot="label">
                      <span>{{
                        "付款比例（%）(" +
                          Arabia_To_SimplifiedChinese(index + 1) +
                          ")"
                      }}</span>
                      <span style="margin-left: 50px" v-if="editMode" class="color-blue pointer" type="text" v-preventReClick @click="removePaymentInfo(row)">删除</span>
                    </label>
                    <el-input-number :disabled="!editMode" v-model="row.paymentRatio" :min="0" :precision="2" :controls="false" placeholder="请填写付款比例" @change="paymentRatioChange(row)" style="width: 90%"></el-input-number>
                    <!-- <el-input :disabled="!editMode" v-model="row.paymentRatio" placeholder="请填写付款比例" style="width:90%" @change="paymentRatioChange(row)"></el-input> -->
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="付款金额" :prop="'paymentDetails.' + index + '.paymentAmount'" :rules="paymentRules.paymentAmount">
                    <el-input-number :disabled="!editMode" v-model="row.paymentAmount" :min="0" :precision="4" :controls="false" placeholder="请填写付款金额" @change="paymentAmountChange(row)" style="width: 90%"></el-input-number>
                    <!-- <el-input :disabled="!editMode" v-model="row.paymentAmount" placeholder="请填写付款金额" style="width:90%" @change="paymentAmountChange(row)"></el-input> -->
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="付款日期" prop="paymentDate">
                    <el-date-picker :disabled="!editMode" v-model="row.paymentDate" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="请选择付款日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <div v-if="editMode" style="cursor: pointer; margin-left: 10px; width: 96px" v-preventReClick @click="addPaymentInfo">
              <img src="@/assets/icons/plus-blue.png" alt="" class="addbtn" />
              <span style="font-size: 13px; color: #286ab4; margin-left: 5px">新增付款信息</span>
            </div>
          </el-form>
        </div>
      </el-form>

      <el-dialog title="资产明细" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm" :rules="childFormRules">
          <el-row>
            <el-col :span="6">
              <el-form-item label="资产编码" prop="fixedAssetNo">
                <SelectTable :disabled="!editMode" :columns="assetColumns" :placeholder="'请选择资产编码'" :innerName="childForm.fixedAssetNo" :dataList="
                    isNoneAsset ? STATIC_NoneAssets : STATIC_FixedAssets
                  " @filterMethod="getFixedAssetList" @change="selectAsset" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产名称" prop="fixedAssetName">
                <el-input disabled v-model="childForm.fixedAssetName" placeholder="系统自动带出资产名称" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="规格型号" prop="specName">
                <el-input disabled v-model="childForm.specName" placeholder="系统自动带出规格型号" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="品牌" prop="brandName">
                <el-input disabled v-model="childForm.brandName" placeholder="系统自动带出品牌" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="生产厂家" prop="manufacturerName">
                <el-select disabled v-model="childForm.manufacturerName" style="width: 100%" filterable placeholder="请选择生产厂商" :filter-method="getManufacturers" @change="manufacturerChange">
                  <el-option v-for="item in STATIC_Manufacturers" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
                <!-- <el-input disabled v-model="childForm.manufacturerName" placeholder="系统自动带出生产厂商" /> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="注册证" prop="certNo">
                <el-select :disabled="!editMode" v-model="childForm.certNo" style="width: 100%" filterable placeholder="请选择注册证" :filter-method="getRegistCerts" @change="certChange">
                  <el-option v-for="item in STATIC_ManufacturerProductRegistCerts" :key="item.id" :label="item.no" :value="item.id">
                  </el-option>
                </el-select>
                <!-- <el-input disabled v-model="childForm.certNo" placeholder="系统自动带出生产厂商" /> -->
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="单位" prop="unitName">
                <el-input disabled v-model="childForm.unitName" placeholder="系统自动带出单位" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="数量" prop="number">
                <el-input-number :disabled="!editMode" v-model="childForm.number" :min="0" :precision="2" :controls="false" placeholder="请填写数量" @change="childNumberChange" style="width: 100%"></el-input-number>
                <!-- <el-input :disabled="!editMode" v-model="childForm.number" placeholder="请填写数量" @change="childNumberChange" /> -->
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="单价" prop="price">
                <el-input-number :disabled="!editMode" v-model="childForm.price" :min="0" :precision="4" :controls="false" placeholder="请填写单价" @change="childNumberChange" style="width: 100%"></el-input-number>
                <!-- <el-input :disabled="!editMode" v-model="childForm.price" placeholder="请填写单价" @change="childNumberChange" /> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="总金额" prop="amount">
                <el-input disabled v-model="childForm.amount" placeholder="系统自动带出总金额" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="出厂日期" prop="productionDate">
                <el-date-picker :disabled="!editMode" v-model="childForm.productionDate" style="width: 100%" type="date" value-format="yyyy-MM-dd" @change="dueDateChange" placeholder="请选择出厂日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="保修期（月）" prop="warranty">
                <el-input-number :disabled="!editMode" v-model="childForm.warranty" :min="0" :precision="1" :controls="false" placeholder="请填写保修期" @change="dueDateChange" style="width: 100%"></el-input-number>
                <!-- <el-input :disabled="!editMode" v-model="childForm.warranty" @change="dueDateChange" placeholder="请填写保修期" /> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="保修到期时间" prop="dueDate">
                <el-date-picker v-model="childForm.dueDate" disabled style="width: 100%" type="date" value-format="yyyy-MM-dd" placeholder="系统自动带出保修到期时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="配件" prop="parts">
                <el-input disabled v-model="childForm.parts" placeholder="请填写配件" resize="none" type="textarea" :rows="5"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="childForm.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <template v-for="(item, index) in childForm.details">
              <div :key="index">
                <el-col :span="6">
                  <el-form-item prop="capitalSourceName" label="234234">
                    <label slot="label">
                      <span>{{
                        "资金来源(" +
                          Arabia_To_SimplifiedChinese(index + 1) +
                          ")"
                      }}</span>
                      <span v-if="editMode" style="margin-left: 20px" class="color-blue pointer" type="text" v-preventReClick @click="removeCapitalSource(item)">删除</span>
                    </label>

                    <el-select :disabled="!editMode" v-model="item.capitalSourceName" placeholder="请选择资金来源" style="width: 100%" filterable :filter-method="getCapitalSources" @change="csChange(item)">
                      <el-option v-for="item in STATIC_CapitalSources" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="比例/金额">
                    <SeparateInput :disabled="!editMode" :left="item.ratio" :right="item.amount" :maxRight="childForm.amount ? childForm.amount : 0" @change="(left, right) => ratioChange(item, left, right)"></SeparateInput>
                  </el-form-item>
                </el-col>
              </div>
            </template>
          </el-row>

          <div v-if="editMode" style="cursor: pointer; margin-left: 10px; width: 96px" v-preventReClick @click="addCapitalSource">
            <img src="@/assets/icons/plus-blue.png" alt="" class="addbtn" />
            <span style="font-size: 13px; color: #286ab4; margin-left: 5px">新增资金来源</span>
          </div>

          <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button v-if="editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
          <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import { SaveContract, GetContractById, RejectContract } from "@/api";
import {
  PaymentTypeOptions,
  PaymentModeOptions,
  AssetSourceOptions,
  BiddingModeTypeOptions,
  WhetherOptions,
  AcceptInStockOptions,
} from "@/enum";
// import Address from '@/components/address';
// import ElImageViewer from '@/components/elImageViewer'
import SelectTable from "@/components/select-table";
import SeparateInput from "@/components/separate-input";
import MyUpload from "@/components/my-upload";
import { Arabia_To_SimplifiedChinese } from "@/utils/number.js";
import ApproveInfo from "@/components/approve-info";
import UploadFileList from "@/components/upload-file-list";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin],
  components: {
    SelectTable,
    // ElImageViewer,
    SeparateInput,
    MyUpload,
    ApproveInfo,
    UploadFileList,
  },
  data () {
    return {
      form: {},
      PaymentTypeOptions: PaymentTypeOptions,
      PaymentModeOptions: PaymentModeOptions,
      AssetSourceOptions: AssetSourceOptions,
      BiddingModeTypeOptions: BiddingModeTypeOptions,
      WhetherOptions: WhetherOptions,
      AcceptInStockOptions: AcceptInStockOptions,
      Arabia_To_SimplifiedChinese: Arabia_To_SimplifiedChinese,
      rules: {
        name: [
          { required: true, message: "合同名称不能为空", trigger: "blur" },
        ],
        contractCategoryId: [
          { required: true, message: "合同类型不能为空", trigger: "blur" },
        ],
        contractNo: [
          { required: true, message: "合同编号不能为空", trigger: "blur" },
        ],
        supplierName: [
          { required: true, message: "供应商不能为空", trigger: "blur" },
        ],
        supplierContactorName: [
          { required: true, message: "联系人不能为空", trigger: "blur" },
        ],
        supplierPhone: [
          { required: true, message: "联系方式不能为空", trigger: "blur" },
        ],
        contactor: [
          { required: true, message: "甲方联系人不能为空", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "联系方式不能为空", trigger: "blur" },
        ],
        startDate: [
          { required: true, message: "合同签订时间不能为空", trigger: "blur" },
        ],
        endDate: [
          { required: true, message: "合同有效日期不能为空", trigger: "blur" },
        ],
        arrivalDate: [
          { required: true, message: "到货日期不能为空", trigger: "blur" },
        ],
        purchaseMode: [
          { required: true, message: "采购方式不能为空", trigger: "blur" },
        ],
        biddingMode: [
          { required: true, message: "招标形式不能为空", trigger: "blur" },
        ],
        totalBudget: [
          { required: true, message: "预算合计不能为空", trigger: "blur" },
        ],
        paymentType: [
          { required: true, message: "付款类型不能为空", trigger: "blur" },
        ],
      },
      paymentRules: {
        paymentAmount: [
          { required: true, message: "付款金额不能为空", trigger: "blur" },
        ],
      },
      childFormRules: {
        fixedAssetNo: [
          { required: true, message: "资产编码不能为空", trigger: "blur" },
        ],
        number: [{ required: true, message: "数量不能为空", trigger: "blur" }],
        price: [{ required: true, message: "单价不能为空", trigger: "blur" }],
        productionDate: [
          { required: true, message: "出厂日期不能为空", trigger: "blur" },
        ],
        warranty: [
          { required: true, message: "保修期不能为空", trigger: "blur" },
        ],
      },
      editMode: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      openSubformModal: false,
      childForm: {},
      capitalSourcemaxCount: 0,
      reject: RejectContract,

      defaultProps: {
        children: "children",
        label: "name",
      },

      isNoneAsset: false,
    };
  },
  computed: {
    userInfo () {
      return this.$store.state.user.userInfo;
    },
  },
  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }
    // if (query.editMode == 1) {
    //   this.editMode = true
    // }
    this.getUsers();
    this.getSuppliers("");
    this.getContractType("");
    this.getCapitalSources("");
    this.getFixedAssetList("");
    this.getRegistCerts("");
    this.getManufacturers("");
    this.getProductSource();
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetContractById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        // this.deSerializeCapitalSource()
        this.showDetailColumns();
        // this.getFixedAssetList('')
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.form.paymentDetails.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.$refs.childPaymentForm.validate((childValid) => {
          if (!childValid) {
            return;
          }

          if (this.form.paymentDetails && this.form.paymentDetails.length > 0) {
            let ratio = 0;
            this.form.paymentDetails.forEach((item) => {
              ratio += item.paymentRatio * 1;
            });

            if (ratio != 100) {
              this.$my_message(`付款比例之和不等于100`, "warning");
              return;
            }
          }

          SaveContract(this.form).then((res) => {
            this.$my_message(`执行成功`, "success");
            sessionStorage.setItem("editMode", 0);
            this.$router.push({ path: this.getMainPath(this.$route.path) });
          }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
        });
      });
    },
    resetForm () {
      this.form = {
        name: "",
        state: 1,
        supplierContactorName: "",
        supplierPhone: "",
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        details: [],
        paymentDetails: [
          {
            $index: 1,
            paymentRatio: 0,
            paymentAmount: 0,
          },
        ],
        orgCode :sessionStorage.getItem('orgId')
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },

    // 明细表
    handleAddChildForm () {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      this.childForm.details.forEach((e, index) => {
        e.$index = index + 1;
      });
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        fixedAssetNo: "",
        fixedAssetName: "",
        price: 0,
        number: "",
        totalAmount: 0,
        amount: 0,
        productionDate: "",
        warranty: 0,
        dueDate: "",
        parts: "",
        remark: "",
        certId: "",
        certNo: "",
        manufacturerId: "",
        manufacturerName: "",
        brandId: "",
        brandName: "",
        details: [],
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
    },
    pushChildForm (close) {
      this.$refs["childForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        // this.capitalSourceChange()
        let item = this.form.details.find(
          (e) =>
            e.$index != this.childForm.$index &&
            e.assetId == this.childForm.assetId
        );

        if (item && !this.editChildren) {
          // 新增有重复项提示
          // Object.assign(item, this.childForm);
          this.$my_message(`当前资产信息已存在，请去子表编辑！`, "error");
          return;
        } else if (item && this.editChildren) {
          // 编辑且有重复项
          this.$my_message(`当前资产信息已存在，请去子表编辑！`, "error");
          return;
        } else if (!item && this.editChildren) {
          // 编辑
          item = this.form.details.find(
            (e) => e.$index == this.childForm.$index
          );
          Object.assign(item, this.childForm);
        } else {
          this.form.details.push(this.childForm);
        }

        this.showDetailColumns();
        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
        }
      });
    },
    childNumberChange () {
      this.autoAmount();
    },
    autoAmount () {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(2) * 1;
    },
    autoTotalAmount () {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber;
      this.form.totalAmount = totalAmount;

      this.allPaymentAmountChange();
    },

    // 付款信息
    addPaymentInfo () {
      if (!this.form.paymentDetails) {
        this.$set(this.form, "paymentDetails", []);
      }
      this.form.paymentDetails.push({
        $index: this.form.paymentDetails.length + 1,
        paymentRatio: 0,
        paymentAmount: 0,
      });
    },
    removePaymentInfo (row) {
      this.form.paymentDetails = this.form.paymentDetails.filter(
        (i) => i.$index != row.$index
      );
      this.form.paymentDetails.forEach((e, index) => {
        e.$index = index + 1;
      });
    },

    // 资金来源
    addCapitalSource () {
      if (!this.childForm.details) {
        this.$set(this.childForm, "details", []);
      }
      // if (this.childForm.details.length == 3) {
      //   this.$my_message(`资金来源最多只能有3个`,"warning");
      //   return;
      // }
      this.childForm.details.push({
        $index: this.childForm.details.length + 1,
        ratio: 0,
        amount: 0,
      });
    },
    removeCapitalSource (row) {
      this.childForm.details = this.childForm.details.filter(
        (i) => i.$index != row.$index
      );
      this.childForm.details.forEach((e, index) => {
        e.$index = index + 1;
      });
    },
    ratioChange (item, left, right) {
      item.left = left;
      item.right = right;
      // let changeRatio = true; // 改变的是否为比例
      // if (left == item.ratio) {
      //   changeRatio = false;
      // }
      // item.ratio = left;
      // item.amount = right;

      // if (changeRatio) {
      //   item.amount = ((this.childForm.amount * left) / 100).toFixed(2) * 1;
      // } else {
      //   item.ratio = ((right / this.childForm.amount) * 100).toFixed(2) * 1;
      // }
      // this.capitalSourceChange()
    },
    showDetailColumns () {
      this.capitalSourcemaxCount = 0;
      if (this.form.details && this.form.details.length > 0) {
        this.form.details.forEach((item) => {
          if (
            item.details &&
            item.details.length > this.capitalSourcemaxCount
          ) {
            this.capitalSourcemaxCount = item.details.length;
          }
        });
      }
    },
    /**
     * 合同类型选择
     */
    contractChange (val) {
      let item = this.STATIC_ContractType.find((t) => t.id == val);
      let old = this.isNoneAsset;
      if (item) {
        if (item.name == "无形资产") {
          this.isNoneAsset = true;
        } else {
          this.isNoneAsset = false;
        }
      } else {
        this.isNoneAsset = false;
      }
      if (old != this.isNoneAsset) {
        this.form.details = [];
        this.getFixedAssetList();
      }
    },
    // change event
    supplierChange (val) {
      this.form.supplierId = val;
      let item = this.STATIC_Suppliers.find((e) => e.id == val);
      if (item) {
        this.form.supplierContactorName = item.contactor;
        this.form.supplierPhone = item.phone;

        // this.getFixedAssetList()
      }
      // else {
      //   this.STATIC_FixedAssets = []
      // }
    },
    selectAsset (row) {
      this.childForm = Object.assign(this.childForm, row, {
        fixedAssetNo: row.no,
        fixedAssetName: row.name,
        assetId: row.id,
        remark: "",
        id: 0,
        stockState: row.state,
      });
      this.getRegistCerts();
    },
    dueDateChange () {
      this.childForm.dueDate = this.addMonth(
        this.childForm.productionDate,
        this.childForm.warranty
      );
    },
    csChange (item) {
      item.capitalSourceId = item.capitalSourceName;
      let obj = this.STATIC_CapitalSources.find(
        (e) => e.id == item.capitalSourceId
      );
      if (obj) {
        item.capitalSourceName = obj.name;
      }
      // this.capitalSourceChange()
    },
    paymentRatioChange (row) {
      row.paymentAmount =
        ((row.paymentRatio * this.form.totalAmount) / 100).toFixed(2) * 1;
    },
    paymentAmountChange (row) {
      row.paymentRatio =
        ((row.paymentAmount * 100) / this.form.totalAmount).toFixed(2) * 1;
    },
    allPaymentAmountChange () {
      if (this.form.paymentDetails && this.form.paymentDetails.length > 0) {
        this.form.paymentDetails.map((item) => {
          item.paymentAmount =
            ((item.paymentRatio * this.form.totalAmount) / 100).toFixed(2) * 1;
          return item;
        });
      }
    },
    manufacturerChange (val) {
      this.childForm.manufacturerId = val;
    },
    certChange (val) {
      this.childForm.certId = val;
      let item = this.STATIC_ProductRegistCerts.find((e) => e.id == val);
      if (item) {
        this.childForm.manufacturerId = item.manufacturerId;
        this.childForm.manufacturerName = item.manufacturerName;
      }
    },

    // 上传附件
    filesChange (fileList) {
      this.form.fileInfos = fileList;
    },

    getFixedAssetList (keyWord) {
      if (this.isNoneAsset) {
        this.getNoneAssetsByQuerys({ keyWord, state: 1 });
      } else {
        this.getFixedAssetByQuerys({ keyWord, state: 1 });
      }
      // this.GetStocksContainDetailByQuery({ keyWord });
    },
    getRegistCerts (val) {
      this.getProductRegistCertsByManufacturer(
        this.childForm.manufacturerId,
        val
      );
    },
    /**
     * 付款人选择
     */
    userChange (val) {
      this.form.UserId = val;
    },
    receivingDisabledDate (v) {
      if (this.form.startDate) {
        return v.getTime() < new Date(this.form.startDate).getTime();
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
